export enum ScreenContentMode {
  None = 0,
  Playlist = 1,
  Schedule = 2,
  SingleApp = 3,
}
